import React from 'react';
import AboutContainer from './AboutContainer';
import SectionLable from '../SectionLable/SectionLable';
import AboutText from './AboutText';
import { toParagraphs } from '../../utils/paragraphs';


const About = (props) => {
    return(
        <AboutContainer>
            <AboutText>
                {toParagraphs(props.text)}
            </AboutText>
            <SectionLable>
                OUR OFFICES
            </SectionLable>
        </AboutContainer>
    );
}
 
export default About;
